import React from 'react';

export default function Stats() {
	return (
		<div className="row">
			<div className="col-md-6"></div>
			<div className="col-md-6">
				<div className="panel panel-default" id="panel-margin-right">
					<div className="panel-body">
						<div className="grid-container3">
							<div className="grid-item">
								<div className="border-bottom">
									<span className="receipt-stat-label">Average Margin </span>
									<span className="pull-right receipt-stat-value"></span>
								</div>
							</div>
							<div className="grid-item">
								<div className="border-bottom">
									<span className="receipt-stat-label">Total Charges</span>
									<span className="pull-right receipt-stat-value"></span>
								</div>
							</div>
							<div className="grid-item">
								<div className="border-bottom">
									<span className="receipt-stat-label">Total Revenue </span>
									<span className="pull-right receipt-stat-value"></span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
